import { downgradeComponent } from "@angular/upgrade/static";
import * as angular from "angular";
import { LanguageSelectorComponent } from "./languageSelector/languageSelector.component";
import { Translate } from "./translate/translate.directive.ajs";

angular
    .module("app.translate.directives", [])

    .directive("languageSelector", downgradeComponent({ component: LanguageSelectorComponent }))
    .directive("translate", Translate.factory())
    ;
